import { render, staticRenderFns } from "./PersonalDataForm.vue?vue&type=template&id=47c4f1b1&scoped=true"
import script from "./PersonalDataForm.vue?vue&type=script&lang=js"
export * from "./PersonalDataForm.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataForm.vue?vue&type=style&index=0&id=47c4f1b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4f1b1",
  null
  
)

export default component.exports